import { isSuccess } from "@dgs/core";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { useNavigate } from "react-router";
import { EventSaveRequest } from "../../../shared/types/event";
import { eventService } from "../shared/api/eventService";

export function useEventSave(viewType: string) {
	const navigate = useNavigate();
	const queryClient = useQueryClient();

	return useCallback(
		async (request: EventSaveRequest) => {
			const response = await eventService.store(request);

			if (isSuccess(response)) {
				void queryClient.invalidateQueries({ queryKey: eventService.baseKey });
				navigate(`/events/${viewType}/${response.data.data.id}`);
			}
		},
		[navigate, queryClient, viewType],
	);
}
